<template>
    <div class="row justify-center " style="min-width: 800px;min-height: 95vh">
        <div class="card q-pa-md">

            <h4 class="mt-0 mb-3 text-left" style="font-size: 26px; font-weight: 300">
                Edit Email ID
            </h4>
            <q-form ref="form">
                <div class="row q-col-gutter-sm">
                    <div class="col-12">
                        <q-input label="Email*" :rules="[val => val && val.length > 0 || 'Please enter Email',
                        val => val.length && emailPattern.test(val) || 'Invalid Email']"
                            class="searchBox p-2 pt-0 my-3" :style="'font-size: larger;'" lazy-rules type="email"
                            v-model="email"></q-input>
                    </div>
                    <div class="col-12 w-100">
                        <div class="position-relative w-100" style="margin-left: -16px;">
                            <div class="app-fixed-footer w-100" style="padding-left: 14px; bottom: 20px;">
                                <div class="d-flex " style="justify-content: left">
                                    <q-btn @click="updateEmail('form')" class="pd-btn  my-3"
                                        :disable="isUpdateDisable">Verify & Update
                                    </q-btn>
                                    <q-btn @click="closeDialog" class=" my-3 ml-3" color="primary">CANCEL</q-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </q-form>
        </div>
    </div>
</template>
    
<script>
import axios from 'axios';
import Constants from '../../Constants/Constant';


export default {
    name: 'EditEmail',
    data: function () {
        return {
            email: '',
            oldEmail: '',
            user: JSON.parse(localStorage.getItem('user')),
            loggedIn_partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType,
            emailPattern: new RegExp(
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
        }
    },
    created() {
        this.email = this.user.organization.email;
        this.oldEmail = this.user.organization.email;
    },
    mounted() {

    },
    computed: {
        isUpdateDisable() {
            if (this.email == this.oldEmail) {
                return true;
            }
            return false;
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeEditEmailCancelDialog', false)
        },

        updateEmail(name) {
            this.$refs[name].validate().then((success) => {
                if (success) {
                    this.$q.dialog({
                        title: 'Update Email',
                        message: 'Are you Sure, you want to update email?',
                        cancel: true,
                        persistent: true,
                    }).onOk(async () => {
                        const apiUrl = Constants.api_url + 'updateEmail';
                        try {
                            const request = {
                                orgId: this.user.organization.id,
                                email: this.email
                            }
                            const response = await axios.post(apiUrl, request);
                            if (response && response.data) {
                                if (response.data.flag) {
                                    const userDataString = localStorage.getItem('user');
                                    const userData = JSON.parse(userDataString);
                                    userData.organization.email = this.email;
                                    userData.email = this.email;

                                    const updatedUserDataString = JSON.stringify(userData);
                                    localStorage.setItem('user', updatedUserDataString);

                                    this.$q.notify({
                                        position: 'top-right',
                                        message: `Your Email updated successfully.`,
                                    });
                                    this.$emit('closeEditEmailDialog', false);
                                } else {
                                    if (response.data.message) {
                                        this.$q.notify({
                                            position: 'top-right',
                                            message: `${response.data.message}`,
                                        });
                                    } else {
                                        this.$q.notify({
                                            position: 'top-right',
                                            message: `Error in Update Email.`,
                                        });
                                    }
                                }
                            }
                        } catch (error) {
                            console.error("Error in Update Email", error);
                        }
                    })
                } else {
                    this.$q.notify({
                        position: 'top-right',
                        message: `Please review the form errors highlighted in red.`,
                    });
                }
            })
        }
    }
}
</script>
    
<style scoped>
.card {
    text-align: center;
    width: 100%;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: bottom;
    border-radius: 4px;
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
    position: relative;
}

/* .searchBox {
    background: #f2f2f2;
    height: 50px;
    border-radius: 7px;
    padding: 0px;
    transition: 0.3s;
} */

.section-title {
    font-weight: bolder;
    font-size: 16px;
}

.bank-card {
    margin-top: 7px;
}

.card-close-icon {
    margin: -24px -17px 0 0;
}

/deep/ .q-field--outlined .q-field__control {
    padding: 0px !important;
}
</style>
    